import clsx from 'clsx'
import {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponsePagination} from '../../core/QueryResponseProvider'
import {Transactions} from '../../core/_models'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<Transactions>>
}

const TransactionsCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const id = tableProps.column.id
  const {state, updateState} = useQueryRequest()
  const pagination = useQueryResponsePagination()

  const isSelectedForSorting = useMemo(() => {
    return state.sort && state.sort === id
  }, [state, id])
  const order: 'asc' | 'desc' | undefined = useMemo(() => state.order, [state])

  const sortColumn = () => {
    // Avoid sorting for these columns
    if (id === 'actions' || id === 'selection') {
      return
    }

    if (!isSelectedForSorting || order === 'desc') {
      // Default to asc if not sorted or currently desc
      updateState({sort: id, order: 'asc', page: pagination.page, perPage: state.perPage})
    } else if (order === 'asc') {
      // Toggle to desc
      updateState({sort: id, order: 'desc', page: pagination.page, perPage: state.perPage})
    }
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(className, isSelectedForSorting && order && `table-sort-${order}`)}
      style={{cursor: 'pointer'}}
      onClick={sortColumn}
    >
      {title}
      {isSelectedForSorting && order === 'asc' && <span className="sort-arrow"> </span>}
      {isSelectedForSorting && order === 'desc' && <span className="sort-arrow"> </span>}
    </th>
  )
}

export {TransactionsCustomHeader}